import { Tabs, TabsHeader, Tab, Tooltip } from '@material-tailwind/react';
import { CIInfoIcon, Icon } from 'car-insurance/components/common/Icon';
import classNames from 'classnames';
import { WhatsappIcon } from 'components/modulab/Icon';
import React from 'react';

interface CITabsCheckboxProps {
  label?: string;
  options: { label: string; value: string }[];
  value?: string;
  onChange: (value: string) => void;
  labelClass?: string;
  tabsHeaderClass?: string;
  tabClass?: string;
  indicatorClass?: string;
  iconClass?: string;
  activeIconColor?: string;
  inactiveIconColor?: string;
  whatsappIconSize?: number;
  tooltip?: string;
}

export const CITabsCheckbox: React.FC<CITabsCheckboxProps> = ({
  onChange,
  options,
  value,
  label,
  tabsHeaderClass = '',
  tabClass = '',
  indicatorClass = '',
  labelClass = '',
  tooltip = '',
}) => {
  return (
    <div className="relative flex flex-col gap-1 z-1">
      {!!label?.length && (
        <div className="flex gap-1 items-center">
          <p
            className={`text-gray-800 text-base font-medium leading-4 ${labelClass}`}
          >
            {label}
          </p>
          {!!tooltip && (
            <Tooltip
              content={
                <span className="alpha-caption text-white">{tooltip}</span>
              }
              placement="top-start"
              // eslint-disable-next-line tailwindcss/no-arbitrary-value
              className="bg-highlights/gray-dark p-3 z-dropdown max-w-60"
            >
              <div className="flex items-center justify-center">
                <CIInfoIcon />
              </div>
            </Tooltip>
          )}
        </div>
      )}
      <Tabs value={value ?? ''}>
        <TabsHeader
          className={`!bg-gray-200 h-9 p-0.5 rounded-lg ${tabsHeaderClass}`}
          indicatorProps={{ className: `rounded-lg ${indicatorClass}` }}
        >
          {options.map((option) => (
            <Tab
              key={option.value}
              // eslint-disable-next-line tailwindcss/no-arbitrary-value
              className={classNames(
                `font-semibold text-base text-gray-600 w-full sm:py-[6px] sm:px-2 md:py-[7px] md:px-4 ${tabClass}`,
                { '!text-gray-900': option.value === value },
              )}
              value={option.value}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </Tab>
          ))}
        </TabsHeader>
      </Tabs>
    </div>
  );
};

export const CITabsIconsCheckbox: React.FC<CITabsCheckboxProps> = ({
  onChange,
  options,
  value,
  label,
  labelClass,
  tabsHeaderClass,
  iconClass,
  activeIconColor = '#212121',
  inactiveIconColor = '#757575',
  whatsappIconSize = 22,
  indicatorClass = '',
}) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {!!label && (
        <p
          className={`leading-4 text-gray-800 font-medium text-base ${labelClass}`}
        >
          {label}
        </p>
      )}
      <Tabs value={value ?? ''}>
        <TabsHeader
          className={`rounded-lg !bg-gray-200 p-0.5 h-9 ${tabsHeaderClass}`}
          indicatorProps={{
            id: 'tabs-header-indicator',
            className: `rounded-lg ${indicatorClass}`,
          }}
        >
          {options.map((option) => (
            <Tab
              key={option.value}
              className="flex justify-center items-center [&_#tabs-header-indicator]:!translate-x-0"
              value={option.value}
              onClick={() => onChange(option.value)}
            >
              {option.value === 'WA' && (
                <WhatsappIcon
                  color={
                    option.value === value ? activeIconColor : inactiveIconColor
                  }
                  size={whatsappIconSize}
                />
              )}
              {option.value !== 'WA' && (
                <Icon
                  name={option.label}
                  className={classNames(
                    `text-gray-900 text-2xl mt-1 ${iconClass}`,
                    { '!text-gray-600': option.value !== value },
                  )}
                />
              )}
            </Tab>
          ))}
        </TabsHeader>
      </Tabs>
    </div>
  );
};
